import { Navigate, useParams } from "react-router-dom";
import { useAuthContext } from "../hooks/Auth";
import { Component } from "react";

interface ProtectedOrgRouteProps {
  Component: React.ElementType;
  Wrapper?: React.ElementType;
}

const ProtectedOrgRoute = ({ Component, Wrapper }: ProtectedOrgRouteProps) => {
  const { user } = useAuthContext();
  const { idOrganization, idUser } = useParams();

  // En caso de que NO sea un Admin de Dominio, verificamos que el usuario haga parte de la organizacion
  if (!user?.roles.some((rol) => rol.rol === "Admin de Dominio")) {
    let canAccess = true;
    if (user?.roles.some((rol) => rol.rol === "Admin de Organización")) {
      // Verificar si el usuario puede acceder
      canAccess = user?.id_organizacion === idOrganization;
    }

    /* Sino, se redirige */
    if (!canAccess) {
      return <Navigate to="/asistente/menu" replace />;
    }
  }

  // Si hay un Wrapper, lo usamos para envolver el componente
  return Wrapper ? (
    <Wrapper>
      <Component />
    </Wrapper>
  ) : (
    <Component />
  );
};

export default ProtectedOrgRoute;
